import { useEffect, useState } from "react";

export function useWindowWidth() {
    const [width, setWidth] = useState(0);
  
    useEffect(() => {
      // Function to update the width
      const handleResize = () => {
        setWidth(window.innerWidth);
      };
  
      // Initial width setting
      handleResize();
  
      // Add event listener for window resize
      window.addEventListener('resize', handleResize);
  
      // Cleanup on component unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    return width;
  }